import { useContext } from "react";
import { ThemeContext, ThemeContextState } from "../context/ThemeContext";

export interface ThemeWrapperProps {
  children: JSX.Element
};

// wrapper component for setting current theme
const ThemeWrapper = (props: ThemeWrapperProps): JSX.Element | null => {
  const { theme } = useContext(ThemeContext) as ThemeContextState;

  return (
    <div data-theme={theme}>
      {props.children}
    </div>
  );
}

export default ThemeWrapper;
